export const formatStringDate = (dateString: string, yearFirst?: boolean) => {
  const date = new Date(dateString);

  const pad = (num: number) => num.toString().padStart(2, '0');

  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  const isPM = hours >= 12;
  const formattedHour = pad(hours % 12 || 12);
  const time = `${formattedHour}:${minutes}:${seconds} ${isPM ? 'PM' : 'AM'}`
  if (yearFirst) return `${year}-${month}-${day} ${time}`;
  return `${month}/${day}/${year} ${time}`;
};

export const formatDateToString = (date: Date, yearFirst?: boolean) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  if (yearFirst) return `${year}-${month}-${day}`;
  return `${month}/${day}/${year}`;
};

export const formatDateUTCToString = (date: Date, yearFirst?: boolean) => {
  const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0));

  const year = utcDate.getUTCFullYear();
  const month = String(utcDate.getUTCMonth() + 1).padStart(2, '0');
  const day = String(utcDate.getUTCDate()).padStart(2, '0');

  if (yearFirst) return `${year}-${month}-${day}`;
  return `${month}/${day}/${year}`;
};
